/**
 * Resolve a disclosure code for a target framework export.
 * Returns { code, title } mapped to the target framework, or null if the code
 * does not belong to that framework.
 */
export function resolveCodeForFramework(
  code,
  disclosure,
  exportFramework,
  metricMappings,
) {
  if (exportFramework === "All") {
    const mapping = metricMappings?.find((m) => m.masterMetricId === code);
    return { code, title: mapping?.metricName || disclosure?.title || code };
  }

  // masterMetricId group → resolve via metricMappings
  const mapping = metricMappings?.find((m) => m.masterMetricId === code);
  if (mapping) {
    const target = mapping.disclosureMappings.find(
      (d) => d.framework === exportFramework,
    );
    return target
      ? { code: target.disclosureCode, title: target.disclosureTitle }
      : null;
  }

  // Individual disclosure → include only if its framework matches
  if (disclosure?.framework === exportFramework) {
    return { code, title: disclosure.title };
  }
  return null;
}
